import { useTranslation } from '@/hooks/translations';

export const useDashboardItemsData = ({
    range,
    selectedDashboardKeys,
    showQlubDinerFee,
    showTipCard,
    isLegacy,
}: {
    range: string;
    selectedDashboardKeys: string[];
    showQlubDinerFee: boolean;
    showTipCard: boolean;
    isLegacy: boolean;
}) => {
    const { t } = useTranslation('common');

    return [
        {
            key: 'revenue',
            name: 'Revenue',
            dateFilterText: `${t(`Revenue`)} ${range}`,
            tooltipKey: t('Total_Revenue_Selected_Period_TooltipText'),
            enabled: true,
        },
        {
            key: 'discounts',
            name: 'Discount',
            dateFilterText: `${t(`Discount`)} ${range}`,
            tooltipKey: t('Total_Discount_Selected_Period_TooltipText'),
            enabled: false,
        },
        {
            key: 'tips',
            name: 'Tips',
            dateFilterText: `${t(`Tips`)} ${range}`,
            tooltipKey: t('Total_Tip_Amount_Selected_Period_TooltipText'),
            enabled: showTipCard,
        },
        {
            key: 'orders',
            name: 'Orders',
            dateFilterText: isLegacy ? `${t(`Transactions`)} ${range}` : `${t(`Orders`)} ${range}`,
            tooltipKey: t('Total_Orders_Selected_Period_TooltipText'),
            enabled: true,
        },
        {
            key: 'refunds',
            name: 'Refunds',
            dateFilterText: `${t(`Refunds`)} ${range}`,
            tooltipKey: t('Total_Refunds_Selected_Period_TooltipText'),
            enabled: true,
        },
        {
            key: 'dinerFee',
            name: 'Diner Fee',
            dateFilterText: `${t(`Diner Fee`)} ${range}`,
            tooltipKey: t('qlub_Diner_Fee_This_Week_TooltipText'),
            enabled: showQlubDinerFee,
        },
    ].map((item) => {
        if (item.key === 'discounts') {
            return {
                ...item,
                enabled: selectedDashboardKeys.length === 0 ? item.enabled : selectedDashboardKeys.includes('discount'),
                valueIcon1: null,
            };
        }
        if (item.key === 'tips' && !showTipCard) return { ...item, enabled: false, valueIcon1: null };
        return {
            ...item,
            enabled: selectedDashboardKeys.length === 0 ? item.enabled : selectedDashboardKeys.includes(item.key),
            valueIcon1: null,
        };
    });
};
